export enum CacheKeys {
    // Bumped whenever the /categories response shape changes, because the tree is cached
    // with a 24h TTL — a stale cache silently drops new fields. _V2 added `color`, _V3
    // added `crime_type_ids` (the subcategory crime-type filtering). clearContentCache()
    // matches on the prefix, so the bump is covered.
    CATEGORIES = "CATEGORIES_V3",
    ONBOARDING = "ONBOARDING",
    ARTICLES = "ARTICLES",
    COUNTIES = "COUNTIES",
    COUNTRIES = "COUNTRIES",
    MOODS = "MOODS",
    FEELINGS = "FEELINGS",
    FCM_CODE = "FCM_CODE",
    RECOMMENDED_ARTICLES = "recommended_articles",
    GUIDE_CATEGORIES = "guide_categories",
    // _v2 added `is_prefer_not_to_say` to each crime type (the picker's exclusive option).
    // Bumped so the 24h-cached list doesn't silently drop the new field.
    CRIME_TYPES = "crime_types_v2"
}
